import React from 'react';

import IPSProjectScheduling from './ipsscheduling';

function IPSScheduling(props) {
  const { project, handleProjectDetailUpdate,isReadOnly,allDropDownOptions ,phaseDetails,phaseId  } = props;

  return (
    <>
      <IPSProjectScheduling
        project={project}
        
        phaseDetails={phaseDetails}
        phaseId={phaseId}
        allDropDownOptions={allDropDownOptions}
        expediteReasons={allDropDownOptions?.expediteReasons}
        p6Sources={allDropDownOptions?.p6Sources}
        handleProjectDetailUpdate={handleProjectDetailUpdate}
        isReadOnly={isReadOnly}
      />
    </>
  );
}
export default IPSScheduling;
